


































import Vue from 'vue'
import { ActionInterface, BlockAntrfileElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'BlockAntrfileEl',
  props: {
    templateItemData: {
      type: Object as () => BlockAntrfileElInterface,
      required: true
    }
  },
  methods: {
    handleActionClick (action: ActionInterface): void {
      if (action.uri !== undefined) {
        this.getView(action.view, action.content || action.uri, null, action.jumpOnCloseUri)
      }
    }
  }
})
